module.exports = __webpack_public_path__ + "img/vk_btn.2a4ac9e7.png";